import { ref } from 'vue'

type Tone = 'ok' | 'danger'

export interface Toast {
  id: number
  tone: Tone
  message: string
}

const toasts = ref<Toast[]>([])
let seq = 0

function push(tone: Tone, message: string) {
  const id = ++seq
  toasts.value = [...toasts.value, { id, tone, message }]
  setTimeout(
    () => {
      toasts.value = toasts.value.filter((t) => t.id !== id)
    },
    tone === 'danger' ? 6000 : 3200,
  )
}

export function useToastList() {
  return toasts
}

export function useToast() {
  return {
    ok: (message: string) => push('ok', message),
    fail: (message: string) => push('danger', message),
  }
}
